import { api as apiProvider, apiMipe } from '@/core/api/';

export const getProviderName = async (providerId) => {
  return await apiProvider.get(`/api/providers/name/${providerId}`);
};

export const getProvidersByAcademicyearId = async (academicYearId) => {
  return await apiProvider.get(
    `api/providers/list/withsignedcontracts/${academicYearId}`
  );
};

export const getCompaniesWithNationalIdentifier = async () => {
  return await apiProvider.get(
    `api/providers/companies/with-national-identifier`
  );
};

export const getProviderDetail = async (providerId) => {
  return await apiProvider.get(`/api/providers/detail/${providerId}`);
};

export const searchProviders = async (
  fiscalYearId,
  isActive,
  nameSsn,
  page
) => {
  return await apiProvider.get('/api/providers', {
    params: { nameSsn, fiscalYearId, isActive, page },
  });
};

export const createContractService = async (contractId, model) => {
  return await apiProvider.put(
    `/api/providers/contract/service/${contractId}`,
    model
  );
};

export const editContractService = async (model) => {
  return await apiProvider.post('/api/providers/contract/service', model);
};

export const deleteContractService = async (serviceId) => {
  return await apiProvider.delete(
    `/api/providers/contract/service/${serviceId}`
  );
};

export const getContractServices = async (contractId, companyId) => {
  return await apiProvider.get('/api/providers/contract/services', {
    params: { contractId: contractId, companyId: companyId },
  });
};

export const signContract = async (contractId) => {
  return await apiProvider.post(`/api/providers/contract/sign/${contractId}`);
};

export const getSpecialistServiceTypes = async () => {
  return await apiProvider.get('/api/providers/specialists/services');
};

export const getSpecialistServices = async (serviceTypeId) => {
  return await apiProvider.get(
    `/api/providers/specialists/disciplines/${serviceTypeId}`
  );
};

export const getSpecialistAgeRange = async () => {
  return await apiProvider.get('/api/providers/specialists/agerange');
};

export const getCompanyLocationsCurrentYear = async (locationTypeId) => {
  return await apiProvider.get(
    `/api/providers/specialists/servicelocations/${locationTypeId}`
  );
};

export const validateSsn = async (ssn) => {
  return await apiProvider.get(`/api/providers/validate/${ssn}`);
};

export const proposalsCanBeAssignedToEvaluators = async () => {
  return await apiProvider.get(
    '/api/providers/proposal/evaluator/canbeassigned'
  );
};

export const validateProposalsAssignedToEvaluators = async () => {
  return await apiProvider.get(
    '/api/providers/proposal/evaluator/assign/validate'
  );
};

export const previewProposalsAssignedToEvaluators = async () => {
  return await apiProvider.get(
    '/api/providers/proposal/evaluator/assign/preview'
  );
};

export const assignProposalsToEvaluators = async () => {
  return await apiProvider.post('/api/providers/proposal/evaluator/assign');
};

//JA: This must be refactored
export const save = async (model) => {
  const provider = {
    id: 0,
    companyId: 0,
    name: '',
    ssn: '',
    status: '',
    fiscalYear: '',
    fiscalYearId: 0,
    organization: null,
    company: {
      id: 0,
      name: model.generalInfoForm.name,
      organizationId: null,
      companyTypeCd: model.generalInfoForm.type.id,
      nameFirst: model.primaryContactForm.name,
      nameLastMaternal: model.primaryContactForm.motherLastName,
      nameLastPaternal: model.primaryContactForm.lastName,
      isServiceAssistant: false,
      isServiceRequestCompany: false,
      isMainCompany: model.isMainCompany,
      isIncorporatedCompany: false,
      socialSecurityNo: model.ssn,
      parentMainCompanyId: model.parentMainCompanyId,
      deleteFlag: '0',
    },
    location: {
      locationId: 0,
      locationName: '',
      locationSchoolId: null,
      centerId: null,
      locationTelephoneNo: model.primaryContactForm.workPhone,
      locationTelephoneFaxNo: model.primaryContactForm.fax,
      locationTypeId: 0,
      locationWebsiteUrl: model.generalInfoForm.website,
    },
    address: {
      addressId: 0,
      addressDescription: model.physicalAddressForm.annotations,
      addressLine1: model.physicalAddressForm.addressOne,
      addressLine2: model.physicalAddressForm.addressTwo,
      addressLine3: model.physicalAddressForm.addressThree,
      addressName: '',
      addressTypeCd: 1,
      municipalityId: model.physicalAddressForm.municipality.id,
      gpsLatitude: null,
      gpsLongitude: null,
      zipCode: model.physicalAddressForm.zipCode,
    },
    contact: {
      id: 0,
      email: model.primaryContactForm.email,
      nameFirst: model.primaryContactForm.name,
      nameInitial: '',
      nameLastMaternal: model.primaryContactForm.motherLastName,
      nameLastPaternal: model.primaryContactForm.lastName,
      telephoneHomeFaxNo: model.primaryContactForm.fax,
      telephoneHomeNo: '',
      telephoneMobileNo: model.primaryContactForm.phone,
      telephoneWorkFaxNo: '',
      telephoneWorkNo: model.primaryContactForm.workPhone,
      telephoneWorkExtNo: '',
      websiteURL: model.generalInfoForm.website,
      workDepartmentName: model.primaryContactForm.department,
      workPositionTitle: model.primaryContactForm.position,
      deleteFlag: '0',
    },
  };

  return await apiProvider.post('/api/providers/save', provider);
};

export const edit = async (model) => {
  return await apiProvider.post('/api/providers/edit', model);
};

export const getSpecialists = async (params) => {
  return await apiProvider.get('/api/providers/specialists', { params });
};

export const getAppointmentsSpecialists = (properties) => {
  return apiMipe.get(
    `api/company/${properties.companyId}/${properties.academicYearId}/specialists`
  );
};

export const getSpecialistBySSN = (ssn, companyId) => {
  return apiProvider.get(`/api/providers/specialists/${ssn}/${companyId}/info`);
};

export const providersList = async (fiscalYearId, specialistId) => {
  return await apiProvider.get('/api/providers/list', {
    params: { fiscalYearId, specialistId },
  });
};

export const providersWithContractList = async (fiscalYearId, specialistId) => {
  return await apiProvider.get(
    `/api/providers/list/withsignedcontracts/${fiscalYearId}/${specialistId}`
  );
};

export const getContracts = async (companyId, fiscalYearId) => {
  return await apiProvider.get('api/providers/contract', {
    params: { companyId: companyId, fiscalYearId: fiscalYearId },
  });
};

export const getContract = async (contractId) => {
  return await apiProvider.get(`api/providers/contract/detail/${contractId}`);
};

export const insertContractService = async (model) => {
  return await apiProvider.put('api/providers/contract/save', model);
};

export const getPurchaseOrderList = async () => {
  return await apiProvider.get(
    'api/providers/contract/purchaseordernumber/list'
  );
};

export const insertContract = async (model) => {
  return await apiProvider.post('api/providers/contract', model);
};

export const updateContract = async (model) => {
  return await apiProvider.put('api/providers/contract', model);
};

export const getPractitionerTypes = async (specialistId) => {
  return await apiProvider.get(
    `api/providers/specialists/practitionertype/${specialistId}`
  );
};

export const getProviders = async (academicyearId) => {
  return await apiMipe.get(`api/provider/${academicyearId}`);
};

export const getProviderCenters = async (academicyearId, providerId) => {
  return await apiMipe.get(
    `api/provider/${academicyearId}/centers/${providerId}`
  );
};

export const getProviderMunicipalities = async (
  academicyearId,
  providerId,
  centerId
) => {
  return await apiMipe.get(`api/provider/${academicyearId}/municipalities/`, {
    params: {
      providerId: providerId,
      centerId: centerId,
    },
  });
};

export const getProviderLocationServices = async (
  academicyearId,
  providerId,
  centerId,
  municipalityId,
  locationtypeId
) => {
  return await apiMipe.get(`api/provider/${academicyearId}/locationServices/`, {
    params: {
      providerId: providerId,
      centerId: centerId,
      municipalityId: municipalityId,
      locationtypeId: locationtypeId,
    },
  });
};

export const getProviderSpecialists = async (
  academicyearId,
  providerId,
  centerId,
  municipalityId,
  locationtypeId,
  locationId
) => {
  return await apiMipe.get(`api/provider/${academicyearId}/specialists/`, {
    params: {
      providerId: providerId,
      centerId: centerId,
      municipalityId: municipalityId,
      locationtypeId: locationtypeId,
      locationId: locationId,
    },
  });
};

export const getSpecialist = async (specialistId, fiscalYearId) => {
  return await apiProvider.get(
    `api/providers/specialists/${specialistId}/${fiscalYearId}`
  );
};

export const getSpecialistLicenseDisciplines = async (specialistId) => {
  return await apiProvider.get(
    `api/providers/specialists/${specialistId}/licenses/disciplines`
  );
};

export const createSpecialist = async (model) => {
  return await apiProvider.post('api/providers/specialists', model);
};

export const updateSpecialist = async (model) => {
  return await apiProvider.put('api/providers/specialists', model);
};

export const createLicense = async (model) => {
  return await apiProvider.post('api/providers/specialists/license', model);
};

export const editLicense = async (model) => {
  return await apiProvider.put('api/providers/specialists/license', model);
};

export const deleteLicense = async (licenseId) => {
  return await apiProvider.delete(
    `api/providers/specialists/license/${licenseId}`
  );
};

export const createServicePlace = async (model) => {
  return await apiProvider.post(
    'api/providers/specialists/serviceLocation',
    model
  );
};

export const editServicePlace = async (model) => {
  return await apiProvider.put(
    'api/providers/specialists/serviceLocation',
    model
  );
};

export const deleteServicePlace = async (specialistLocationId) => {
  return await apiProvider.delete(
    `api/providers/specialists/serviceLocation/${specialistLocationId}`
  );
};

export const deactivateSpecialist = async (model) => {
  return await apiProvider.post('api/providers/specialists/deactivate', model);
};

export const hasActiveStudentReferral = async (model) => {
  return await apiProvider.get(
    `api/providers/specialists/${model.specialistId}/${model.companyId}/${model.fiscalYearId}/hasactivestudentreferral`
  );
};

export const getAppointmentsCoordinated = async (model) => {
  return await apiProvider.get(
    `api/providers/specialists/getappointmentscoordinatedbyspecialist/${model.specialistId}/${model.companyId}`
  );
};

export const getSpecialistSpecialtyTypes = async () => {
  return await apiProvider.get('/api/providers/specialists/specialtyTypes');
};

export const getSupervisedSpecialist = async (
  specialistId,
  supervisedType,
  specialistName,
  ssn,
  page
) => {
  return await apiProvider.get(
    `/api/providers/specialists/supervisedspecialist?specialistId=${specialistId}&supervisedType=${supervisedType}&specialistName=${specialistName}&ssn=${ssn}&page=${page}&pageSize=5`
  );
};

export const saveSupervised = async (model) => {
  return await apiProvider.post(
    '/api/providers/specialists/savesupervisedinfo',
    model
  );
};

export const getSupervisedInfo = async (
  specialistId,
  academicYearId,
  companyId
) => {
  return await apiProvider.get(
    `/api/providers/specialists/supervisedinfo?specialistId=${specialistId}&academicYearId=${academicYearId}&companyId=${companyId}`
  );
};

export const getSpecialistExcemptions = async (specialistId, companyId) => {
  return await apiProvider.get(
    `/api/providers/specialists/${companyId}/${specialistId}/GetSpecialistExcemptions`
  );
};

export const getAmendments = async (model) => {
  return await apiProvider.get(
    `api/providers/contract/amendments/${model.contractId}/${model.companyId}/${model.fiscalYearId}`
  );
};

export const insertContractAmendment = async (model) => {
  return await apiProvider.post(`api/providers/contract/amendment`, model);
};

export const getSpecialtyDisciplines = async (specialtyIds) => {
  return await apiProvider.post(
    '/api/providers/specialists/licenses/specialties/disciplines',
    specialtyIds
  );
};

export const getResources = async (keys) => {
  const messageCode = keys.join('&messageCodes=');
  const { data } = await apiMipe.get(
    `/api/validationsmessages?messageCodes=${messageCode}`
  );
  if (data) {
    return data;
  }

  return [];
};

export const loadValidationMessages = async (keys) => {
  let messages = await getResources(keys);

  let result = {};

  for (let i = 0; i < messages.length; i++) {
    result[messages[i].id] = messages[i].name;
  }
  //Example Data:
  /** One Object with Properties
   * result["R3085494"] = "Message Content";
   * result["R3085495"] = "Message Content";
   */

  return result;
};

export const searchAvailableDates = async (params) => {
  return await apiMipe.get('/api/appointment/searchdates', {
    params: params,
  });
};

export const getValidAppointmentDisciplines = async (serviceTypeId) => {
  return await apiMipe.get(
    `api/appointment/getvalidappointmentdisciplinesforddl/${serviceTypeId}`
  );
};

export const hasActiveCoordinatedDiscipline = async (params) => {
  return await apiMipe.get('/api/appointment/hasactivecoordinateddiscipline', {
    params: params,
  });
};

export const getMunicipalitiesByDiscipline = async (params) => {
  return await apiMipe.get('/api/appointment/getmunicipalitiesbydicipline', {
    params: params,
  });
};

export const getBreach = async (params) => {
  return await apiMipe.get('/api/appointment/getbreach', {
    params: params,
  });
};

export const getRegistrationDate = async (studentSieId) => {
  return await apiMipe.get(
    `/api/appointment/getregistrationdate?studentSieId=${studentSieId}`
  );
};

export const getStudentDetail = async (studentSieId) => {
  return await apiMipe.get('/api/student/getstudentdetails', {
    params: { studentSie: studentSieId },
  });
};

export const getAppointmentInfo = async (clientAppointmentId) => {
  return await apiMipe.get(
    'api/appointment/info?clientAppointmentId=' + clientAppointmentId
  );
};

export const getRelationships = async () => {
  return await apiMipe.get('api/student/eduespcodes');
};

export const getPhoneProviders = async () => {
  return await apiMipe.get('api/student/TelephoneProviders');
};

export const getContactInformation = async (studentSieId) => {
  return await apiMipe.get(`api/student/${studentSieId}/ContactInformation`);
};

export const getCenterbyUserId = async (userId) => {
  return await apiMipe.get(
    `api/eduespuserlocation/servicecenterbyuserid?userId=${userId}`
  );
};

export const getCenters = async () => {
  return await apiMipe.get('api/code/servicecenter');
};

export const saveAppointmentCoordinate = async (data) => {
  return await apiMipe.post('/api/appointment/coordinate', data);
};

export const getStudentDetails = async (studentSieId) => {
  return await apiMipe.get(`api/student/card/studentdetails/${studentSieId}`);
};

export const getStudentSsn = async (studentSieId) => {
  return await apiMipe.get(`api/student/ssn/${studentSieId}`);
};

export const searchUsers = async (payload) => {
  return await apiProvider.get(`api/providers/specialists/searchusers`, {
    params: payload,
  });
};

export const saveSpecialistVisits = async (model) => {
  return await apiProvider.post(
    'api/providerregistryvisit/addstudentvisit',
    model,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );
};

export const getProviderInfoDocumentTypes = async () => {
  return await apiProvider.get(`api/providers/providerinfodocumenttypes`);
};

export const uploadProviderInfoDocument = async (params) => {
  return await apiProvider.post(
    'api/providers/uploadproviderinfodocument',
    params,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};
